<template>
  <div class="all-cate-container">
    <!-- 筛选条件区域 -->
    <div class="filter-section">
      <div class="section-title">药房出库统计</div>
      <el-form :model="filterForm">
        <div class="filter-form">
          <!-- 单据日期 -->
          <el-form-item label="单据日期">
            <el-radio-group v-model="filterForm.dateRangeType" @change="handleDateRangeChange" size="mini">
              <el-radio-button label="today">今天</el-radio-button>
              <el-radio-button label="yesterday">昨天</el-radio-button>
              <el-radio-button label="last7days">近7天</el-radio-button>
              <el-radio-button label="lastMonth">近1月</el-radio-button>
              <el-radio-button label="custom">自定义</el-radio-button>
            </el-radio-group>
            
            <el-date-picker
              v-if="filterForm.dateRangeType === 'custom'"
              v-model="filterForm.customDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              size="mini"
              style="margin-left: 10px; width: 240px;"
              @change="handleCustomDateRangeChange"
            />
          </el-form-item>

          <!-- 单据状态 -->
          <el-form-item label="单据状态">
            <el-select 
              v-model="filterForm.state" 
              size="mini" 
              placeholder="全部状态" 
              :disabled="loading"
              @change="handleStateChange"
            >
              <el-option label="全部状态" value="" />
              <el-option label="草稿" :value="0" />
              <el-option label="已提交" :value="2" />
              <el-option label="已审核" :value="4" />
              <el-option label="已过单" :value="5" />
              <el-option label="已冲销" :value="6" />
            </el-select>
          </el-form-item>

          <!-- 调拨单号 -->
          <el-form-item label="调拨单号">
            <el-input 
              v-model="filterForm.documentNo" 
              placeholder="请输入调拨单号" 
              size="mini"
              clearable
              style="width: 200px;"
              @clear="handleSearch"
              @keyup.enter="handleSearch"
            />
          </el-form-item>

          <!-- 查询按钮 -->
          <el-button 
            type="primary" 
            size="mini" 
            icon="el-icon-Ssearch"
            @click="handleSearch"
            :disabled="loading"
            :loading="searchLoading"
          >
            {{ searchLoading ? '查询中...' : '查询' }}
          </el-button>
        </div>
      </el-form>
    </div>

    <!-- 动态显示子组件 -->
    <div class="component-container">
      <el-tabs v-model="activeTab" type="border-card" class="content-tabs" @tab-click="handleTabChange">
        <!-- 西药库标签页 -->
        <el-tab-pane label="西药房出库统计" name="xy" class="tab-pane-content">
          <XyReturn
            ref="xyComponent"
            :key="`xy-${componentKey}`"
            :out-warehouse="3"
            :state="filterForm.state"
            :start-date="currentStartDate"
            :end-date="currentEndDate"
            :document-no="filterForm.documentNo"
            @reload="handleReload"
          />
        </el-tab-pane>
        
        <!-- 中药库标签页 -->
        <el-tab-pane label="中药房出库统计" name="zy" class="tab-pane-content">
          <ZyReturn
            ref="zyComponent"
            :key="`zy-${componentKey}`"
            :out-warehouse="2"
            :state="filterForm.state"
            :start-date="currentStartDate"
            :end-date="currentEndDate"
            :document-no="filterForm.documentNo"
            @reload="handleReload"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import XyReturn from './XyReturn.vue';
import ZyReturn from './ZyReturn.vue';
import dayjs from 'dayjs';

export default {
  name: 'AllCateParent',
  components: {
    XyReturn,
    ZyReturn
  },
  data() {
    return {
      activeTab: 'xy',
      filterForm: {
        dateRangeType: 'today',
        customDateRange: [],
        state: '',
        documentNo: '',
        outWarehouse: 3
      },
      loading: false,
      searchLoading: false,
      componentKey: 0,
      // 当前日期范围
      currentStartDate: '',
      currentEndDate: '',
      // 防止重复请求的标识
      isRequesting: false,
      lastRequestTime: 0,
      requestDebounce: 500 // 防抖时间500ms
    };
  },
  computed: {
    currentComponentName() {
      return this.activeTab === 'xy' ? '西药库' : 
             this.activeTab === 'zy' ? '中药库' : '未选择';
    },
    
    currentWarehouseId() {
      return this.activeTab === 'xy' ? 1 : 2;
    }
  },
  mounted() {
    console.log('初始化完成，默认显示西药库');
    this.filterForm.outWarehouse = this.currentWarehouseId;
    this.setDefaultDateRange();
    // 初始化后立即加载数据
    this.$nextTick(() => {
      this.handleSearch();
    });
  },
  methods: {
    // 设置默认日期范围
    setDefaultDateRange() {
      this.updateDateRange();
    },
    
    // 更新日期范围
    updateDateRange() {
      const dateRange = this.formatApplyDate();
      this.currentStartDate = dateRange[0];
      this.currentEndDate = dateRange[1];
      console.log('更新日期范围:', this.currentStartDate, '至', this.currentEndDate);
    },
    
    // 处理日期范围变化
    handleDateRangeChange() {
      if (this.filterForm.dateRangeType !== 'custom') {
        this.filterForm.customDateRange = [];
      }
      this.updateDateRange();
      // 使用防抖方式调用查询
      this.debouncedSearch();
    },
    
    // 处理自定义日期范围变化
    handleCustomDateRangeChange() {
      if (this.filterForm.dateRangeType === 'custom' && 
          this.filterForm.customDateRange && 
          this.filterForm.customDateRange.length === 2) {
        this.updateDateRange();
        this.debouncedSearch();
      }
    },
    
    // 处理状态变化
    handleStateChange() {
      this.debouncedSearch();
    },
    
    // 防抖搜索函数
    debouncedSearch() {
      const now = Date.now();
      if (now - this.lastRequestTime < this.requestDebounce) {
        clearTimeout(this.debounceTimer);
      }
      
      this.debounceTimer = setTimeout(() => {
        this.handleSearch();
      }, this.requestDebounce);
      
      this.lastRequestTime = now;
    },
    
    // 格式化日期范围
    formatApplyDate() {
      let startDate = '';
      let endDate = '';
      
      const today = dayjs();
      
      switch(this.filterForm.dateRangeType) {
        case 'today':
          startDate = `${today.format('YYYY-MM-DD')} 00:00:00`;
          endDate = `${today.format('YYYY-MM-DD')} 23:59:59`;
          break;
        case 'yesterday':
          const yesterday = today.subtract(1, 'day');
          startDate = `${yesterday.format('YYYY-MM-DD')} 00:00:00`;
          endDate = `${yesterday.format('YYYY-MM-DD')} 23:59:59`;
          break;
        case 'last7days':
          const sevenDaysAgo = today.subtract(7, 'day');
          startDate = `${sevenDaysAgo.format('YYYY-MM-DD')} 00:00:00`;
          endDate = `${today.format('YYYY-MM-DD')} 23:59:59`;
          break;
        case 'lastMonth':
          const oneMonthAgo = today.subtract(1, 'month');
          startDate = `${oneMonthAgo.format('YYYY-MM-DD')} 00:00:00`;
          endDate = `${today.format('YYYY-MM-DD')} 23:59:59`;
          break;
        case 'custom':
          if (this.filterForm.customDateRange && this.filterForm.customDateRange.length === 2) {
            const [start, end] = this.filterForm.customDateRange;
            startDate = `${dayjs(start).format('YYYY-MM-DD')} 00:00:00`;
            endDate = `${dayjs(end).format('YYYY-MM-DD')} 23:59:59`;
          } else {
            startDate = `${today.format('YYYY-MM-DD')} 00:00:00`;
            endDate = `${today.format('YYYY-MM-DD')} 23:59:59`;
          }
          break;
        default:
          startDate = `${today.format('YYYY-MM-DD')} 00:00:00`;
          endDate = `${today.format('YYYY-MM-DD')} 23:59:59`;
      }
      
      return [startDate, endDate];
    },

    // 处理标签页切换
    async handleTabChange(tab) {
      if (this.isRequesting) {
        return;
      }
      
      const warehouseName = tab.name === 'xy' ? '西药库' : '中药库';
      this.filterForm.outWarehouse = tab.name === 'xy' ? 1 : 2;
      
      console.log(`切换到${warehouseName}数据`);
      
      // 切换标签页后立即加载数据
      this.$nextTick(() => {
        this.handleSearch();
      });
      
      this.$message.success(`已切换到${warehouseName}数据`);
    },

    // 修改查询方法 - 只查询当前激活的子组件
    async handleSearch() {
      if (this.isRequesting) {
        console.log('已有请求在进行中，跳过本次请求');
        return;
      }
      
      if (!this.activeTab) {
        this.$message.warning('请先选择药库类型');
        return;
      }
      
      this.isRequesting = true;
      this.searchLoading = true;
      const warehouseName = this.currentComponentName;
      
      try {
        console.log(`开始查询${warehouseName}数据`);
        console.log('查询日期范围:', this.currentStartDate, '至', this.currentEndDate);
        console.log('查询状态:', this.filterForm.state);
        console.log('查询调拨单号:', this.filterForm.documentNo);
        
        // 只更新当前激活的子组件
        const componentRef = this.$refs[`${this.activeTab}Component`];
        if (componentRef && componentRef.loadTransferData) {
          await componentRef.loadTransferData({
            startDate: this.currentStartDate,
            endDate: this.currentEndDate,
            state: this.filterForm.state,
            documentNo: this.filterForm.documentNo
          });
        }
        
        this.$message.success(`${warehouseName}数据查询完成`);
      } catch (error) {
        console.error('查询失败:', error);
        this.$message.error('查询失败，请重试');
      } finally {
        this.isRequesting = false;
        this.searchLoading = false;
      }
    },
    
    // 处理子组件重新加载请求
    handleReload() {
      console.log('子组件请求重新加载');
      // 只重新加载当前激活的子组件
      const componentRef = this.$refs[`${this.activeTab}Component`];
      if (componentRef && componentRef.loadTransferData) {
        componentRef.loadTransferData({
          startDate: this.currentStartDate,
          endDate: this.currentEndDate,
          state: this.filterForm.state,
          documentNo: this.filterForm.documentNo
        });
      }
    }
  },
  
  beforeUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
};
</script>

<style lang="less" scoped>
.all-cate-container {
  padding: 20px;
  background-color: #f5f7fa;
  height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.filter-section {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  .section-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #303133;
    padding-left: 10px;
    border-left: 4px solid #409EFF;
  }
  
  .filter-form {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    
    /deep/ .el-form-item {
      margin-bottom: 0;
      display: flex;
      align-items: center;
      
      .el-form-item__label {
        font-weight: 600;
        color: #606266;
        padding-right: 10px;
        white-space: nowrap;
        width: 80px;
        text-align: right;
      }
      
      .el-radio-group {
        display: flex;
        align-items: center;
        
        .el-radio-button {
          margin-right: 5px;
          
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    
    .el-button {
      margin-bottom: 0;
      min-width: 80px;
      margin-top: 3px;
    }
  }
}

.component-container {
  flex: 1;
  overflow: hidden;
  position: relative;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  // 内容区域标签页样式
  .content-tabs {
    height: 100%;
    border: none;
    border-radius: 8px;
    
    /deep/ .el-tabs__header {
      background-color: #f5f7fa;
      border-bottom: 1px solid #e6e8eb;
      border-radius: 8px 8px 0 0;
      margin-bottom: 0;
      
      .el-tabs__nav-wrap {
        border-radius: 8px 8px 0 0;
      }
      
      .el-tabs__item {
        font-size: 14px;
        font-weight: 600;
        padding: 0 24px;
        height: 40px;
        line-height: 40px;
        
        &.is-active {
          background-color: #fff;
          color: #409EFF;
          border-bottom: 2px solid #409EFF;
        }
        
        &:not(.is-active):hover {
          color: #409EFF;
        }
      }
    }
    
    /deep/ .el-tabs__content {
      height: calc(100% - 40px);
      padding: 0;
      overflow: hidden;
    }
    
    .tab-pane-content {
      height: 100%;
      padding: 0;
      overflow: hidden;
    }
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .filter-section {
    .filter-form {
      gap: 15px;
      
      /deep/ .el-form-item {
        flex: 1 1 calc(50% - 15px);
        min-width: 300px;
      }
    }
  }
}

@media (max-width: 768px) {
  .all-cate-container {
    padding: 10px;
  }
  
  .filter-section {
    padding: 15px;
    
    .filter-form {
      flex-direction: column;
      align-items: stretch;
      gap: 15px;
      
      /deep/ .el-form-item {
        flex: 1 1 100%;
        min-width: auto;
        margin-right: 0;
        flex-direction: column;
        align-items: flex-start;
        
        .el-form-item__label {
          width: 100%;
          margin-bottom: 5px;
          padding-right: 0;
          text-align: left;
        }
        
        .el-radio-group {
          width: 100%;
          justify-content: space-between;
          
          .el-radio-button {
            flex: 1;
            margin-right: 5px;
            
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      
      .el-button {
        margin-left: 0;
        width: 100%;
      }
    }
  }
  
  .component-container {
    .content-tabs {
      /deep/ .el-tabs__item {
        padding: 0 12px;
        font-size: 13px;
      }
    }
  }
}

/* 小屏幕适配 */
@media (max-width: 480px) {
  .filter-section {
    .filter-form {
      .el-radio-group {
        /deep/ .el-radio-button {
          font-size: 12px;
          padding: 0 8px;
        }
      }
    }
  }
  
  .component-container {
    .content-tabs {
      /deep/ .el-tabs__item {
        padding: 0 8px;
        font-size: 12px;
      }
    }
  }
}
</style>